import { render } from "./ListItemForm.vue?vue&type=template&id=5aba994a&scoped=true"
import script from "./ListItemForm.vue?vue&type=script&lang=js"
export * from "./ListItemForm.vue?vue&type=script&lang=js"

import "./ListItemForm.vue?vue&type=style&index=0&id=5aba994a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aba994a"]])

export default __exports__